import React from "react";
import PropTypes from "prop-types";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import pt_PT from "@react-pdf-viewer/locales/lib/pt_PT.json";

const DocumentViewer = ({ base64, onSign, previousDocument, lastDocument, returnDocumentPrevious, nextDocument, amountOfDocuments, currentDocumentPosition, documentNotSigned, userNeedSeeAllDocsBeforeSign }) => {
  const getFilePluginInstance = getFilePlugin({
    fileNameGenerator: (file) => {
      // `file.name` is the URL of opened file
      const fileName = file.name.substring(file.name.lastIndexOf("/") + 1);
      // nome do documento com a extenção pdf
      return `copia-de-${fileName}.pdf`;
      // return `a-copy-of-${fileName}`;
    },
  });
  const { DownloadButton } = getFilePluginInstance;

  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const { CurrentPageLabel, Download, GoToNextPage, GoToPreviousPage, NumberOfPages, Zoom, ZoomIn, ZoomOut } = slots;
        return (
          <div
            style={{
              alignItems: "center",
              display: "flex",
              width: "100%",
              fontFamily: "Helvetica",
            }}
          >
            <div style={{ padding: "0px 2px" }}>
              <GoToPreviousPage />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <CurrentPageLabel /> / <NumberOfPages />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <GoToNextPage />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <ZoomOut />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Zoom />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomIn />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <DownloadButton />
            </div>
          </div>
        );
      }}
    </Toolbar>
  );

  const handleClick = (param) => {
    onSign({ signed: param });
  };

  const handleNotSign = () => {
    documentNotSigned();
  };

  const goNextDocument = async () => {
    nextDocument();
  };

  const goPreviousDocument = async () => {
    returnDocumentPrevious();
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [],
    renderToolbar: renderToolbar,
  });

  return (
    <>
      <div style={{ height: "100dvh" }}>
        <div className="d-flex flex-row justify-content-around align-items-center pb-2 pt-2">
          {previousDocument !== null && (
            <>
              <button className="btn btn-primary" disabled={!previousDocument} onClick={() => goPreviousDocument()} style={{ padding: "10px 22px 10px 22px" }}>
                <i className="fa fa-angle-double-left" style={{ fontSize: "18px" }} />
              </button>
            </>
          )}
          <p className="h4">
            Documento {" " + currentDocumentPosition}/{amountOfDocuments}
          </p>
          <>
            <button className="btn btn-primary" onClick={() => goNextDocument()} disabled={lastDocument} style={{ padding: "10px 22px 10px 22px" }}>
              <i className="fa fa-angle-double-right" style={{ fontSize: "18px" }} />
            </button>
          </>
        </div>
        <div style={{ height: "calc(89dvh - 130px)", margin: "0 20px 0 20px" }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
            <Viewer
              fileUrl={base64}
              localization={pt_PT}
              plugins={[defaultLayoutPluginInstance, getFilePluginInstance]}
              transformGetDocumentParams={(options) => Object.assign({}, options, { isEvalSupported: false })}
            />
          </Worker>
        </div>
        <div className="d-flex flex-column justify-content-center p-3">
          {(!userNeedSeeAllDocsBeforeSign || lastDocument) && (
            <div className="w-100">
              <button className="btn btn-primary w-100 fw-bold pl-2 pr-2" type="button" onClick={() => handleClick(1)}>
                ASSINAR DOCUMENTO
              </button>
            </div>
          )}
          {!!userNeedSeeAllDocsBeforeSign && !lastDocument && (
            <div className="d-flex flex-row justify-content-center gap-3">
              {previousDocument && (
                <button className="btn btn-primary" type="button" onClick={() => goPreviousDocument()}>
                  &#10094; Documento Anterior
                </button>
              )}
              <button className="btn btn-primary" type="button" onClick={() => goNextDocument()}>
                Próximo Documento &#10095;
              </button>
            </div>
          )}
          {!!userNeedSeeAllDocsBeforeSign && lastDocument && previousDocument && (
            <div className="d-flex flex-row justify-content-center gap-3 pt-2">
              <button className="btn btn-primary" type="button" onClick={() => goPreviousDocument()}>
                &#10094; Documento Anterior
              </button>
            </div>
          )}
          <div className="w-100 pt-2">
            <p className="text-center h5 text-danger" type="button" onClick={() => handleNotSign()} style={{ textDecoration: "underline" }}>
              Recusar Documento
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

DocumentViewer.propTypes = {
  base64: PropTypes.string.isRequired,
  onSign: PropTypes.func.isRequired,
  previousDocument: PropTypes.bool.isRequired,
  lastDocument: PropTypes.bool.isRequired,
  returnDocumentPrevious: PropTypes.func.isRequired,
  nextDocument: PropTypes.func.isRequired,
  amountOfDocuments: PropTypes.number.isRequired,
  currentDocumentPosition: PropTypes.number.isRequired,
  documentNotSigned: PropTypes.func.isRequired,
  userNeedSeeAllDocsBeforeSign: PropTypes.bool,
};

export default DocumentViewer;
